import { render, staticRenderFns } from "./AutomaticIssueDetailsPopup.vue?vue&type=template&id=36001afa&scoped=true"
import script from "./AutomaticIssueDetailsPopup.vue?vue&type=script&lang=js"
export * from "./AutomaticIssueDetailsPopup.vue?vue&type=script&lang=js"
import style0 from "./AutomaticIssueDetailsPopup.vue?vue&type=style&index=0&id=36001afa&prod&lang=scss"
import style1 from "./AutomaticIssueDetailsPopup.vue?vue&type=style&index=1&id=36001afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36001afa",
  null
  
)

export default component.exports